import axiosInstance from '../../../config/axiosInstance';
import { CustomerDiscountValidation } from "../View/Validation/CustomerDiscountValidation";

const handleChange = (event, formData, setFormData) => {
  const { name, value } = event.target;
  setFormData({
    ...formData,
    [name]: value,
  });
};

const handleSubmit = async (event, formData, setFormData, setErrors, redirectCallback, redirectRoleList) => {
  debugger;
  event?.preventDefault();
  const formErrors = CustomerDiscountValidation(formData);
  setErrors(formErrors);
  if (Object.keys(formErrors).length === 0) {
    try {
      const CompanyID = localStorage.getItem("CompanyID");
      formData.ClientID = CompanyID;
      const UserID = localStorage.getItem("UserID");
      formData.UserID = UserID;
      const response = await axiosInstance.post(`/Customer/CreateCustomerDiscount`,formData);
      return response.data; 
     
    } catch (error) {
      console.error('Error posting data:', error);
    }
  }
};

export { handleChange, handleSubmit };